/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "OwnerType": {
            "values": {
              "UNKNOWN_OWNER_TYPE_DO_NOT_USE": 0,
              "MERCHANT": 1,
              "UNIT": 2
            }
          },
          "Owner": {
            "fields": {
              "type": {
                "type": ".squareup.banking.OwnerType",
                "id": 1,
                "rule": "optional"
              },
              "id": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "AccountType": {
            "values": {
              "UNKNOWN_ACCOUNT_TYPE_DO_NOT_USE": 0,
              "CLEARING_ACCOUNT": 1,
              "CHECKING_ACCOUNT": 2,
              "MANUAL_SETTLEMENT_CHECKING_ACCOUNT": 3,
              "SAVINGS_ACCOUNT": 4,
              "FOLDERS_ACCOUNT": 5
            }
          },
          "AccountState": {
            "values": {
              "UNKNOWN_ACCOUNT_STATE_DO_NOT_USE": 0,
              "OPEN": 1,
              "CLOSED": 2,
              "FROZEN": 3
            }
          },
          "TransferType": {
            "values": {
              "UNKNOWN_TRANSFER_TYPE_DO_NOT_USE": 0,
              "DEBIT_CARD_PAY_IN": 1,
              "SAME_DAY_PAYOUT": 2,
              "STANDARD_SPEED_PAYOUT": 3,
              "INSTANT_PAYOUT": 4,
              "DEBIT_CARD_PAY_IN_CHARGEBACK": 5,
              "CHECK_PAY_IN": 6,
              "CHECK_PAY_OUT": 16,
              "BALANCE_TRANSFER": 7,
              "ACH_PAY_IN": 8,
              "DIRECT_DEPOSIT_IN": 9,
              "DIRECT_DEPOSIT_OUT": 10,
              "SUBSCRIPTIONS": 11,
              "SUBSCRIPTIONS_REFUND": 15,
              "PAYROLL_INSTANT_PAYOUT": 12,
              "BILL_PAYMENT": 13,
              "BALANCE_TRANSFER_CHARGEBACK": 14
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.OwnerType && !$root.nested?.squareup?.nested?.banking?.nested?.Owner && !$root.nested?.squareup?.nested?.banking?.nested?.AccountType && !$root.nested?.squareup?.nested?.banking?.nested?.AccountState && !$root.nested?.squareup?.nested?.banking?.nested?.TransferType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE OwnerType @ squareup/banking/common.proto at 11:1
 */
export const OwnerType = $root.lookupEnum('squareup.banking.OwnerType').values;
/**
 * Represents a relation between an object within the banking API and an entity within the wider
 * Square ecosystem (e.g. a unit, a merchant, an employee, etc.). Currently this is used just for
 * Accounts, but it is applicable to other kinds of models as well (e.g. transfers, saving goals, etc.)
 *
 * SOURCE Owner @ squareup/banking/common.proto at 22:1
 */
export const Owner = $root.lookupType('squareup.banking.Owner');
fixType(Owner);
Builder.createAndAttachToType(Owner);
/**
 * SOURCE AccountType @ squareup/banking/common.proto at 36:1
 */
export const AccountType = $root.lookupEnum('squareup.banking.AccountType').values;
/**
 * SOURCE AccountState @ squareup/banking/common.proto at 73:1
 */
export const AccountState = $root.lookupEnum('squareup.banking.AccountState').values;
/**
 * SOURCE TransferType @ squareup/banking/common.proto at 80:1
 */
export const TransferType = $root.lookupEnum('squareup.banking.TransferType').values;